export const isMobileDevice = () => {
  if (!navigator) {
    return false
  }

  const mobileUserAgentsRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i
  const userAgent = navigator.userAgent
  const userPlatform = navigator.userAgentData?.platform || navigator.platform || ''
  const isMobileUserPlatform = navigator.userAgentData?.mobile || false

  return mobileUserAgentsRegExp.test(userAgent) || mobileUserAgentsRegExp.test(userPlatform) || isMobileUserPlatform
}

export const isAvailableLocalStorage = () => {
  try {
    localStorage.setItem('test', 'test_val')
    localStorage.removeItem('test')
    return true
  } catch(error) {
    return false
  }
}
